import withProps from 'recompose/withProps'

const contents = {
  date: {
    name: '日期',
    type: 'Date',
    format: 'YYYY/MM/DD',
  },
}

module.exports = withProps({
  schema: {
    name: 'Long Format 資料',
    type: 'Object',
    contents,
  },
  contents,
  fields: ['date'],
})



// WEBPACK FOOTER //
// ./src/components/IncomeStatement/withSchema.js